import { useMemo } from 'react';
import { Empty } from 'antd';
import type { CallbackDataParams } from 'echarts/types/dist/shared';

import type { ScatterChartOption } from '../../../../models/echarts';
import { ReactECharts } from '../../../charts/ReactECharts';

const hours = [
  '12a',
  '1a',
  '2a',
  '3a',
  '4a',
  '5a',
  '6a',
  '7a',
  '8a',
  '9a',
  '10a',
  '11a',
  '12p',
  '1p',
  '2p',
  '3p',
  '4p',
  '5p',
  '6p',
  '7p',
  '8p',
  '9p',
  '10p',
  '11p',
];
const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

const getOption = (data: [number, number, number][]) => {
  const sum = data.reduce((acc, d) => acc + d[2], 0);
  if (!(data && data.length > 0 && sum > 0)) {
    return;
  }

  const title: ScatterChartOption['title'] = [];
  const singleAxis: ScatterChartOption['singleAxis'] = [];
  const series: ScatterChartOption['series'] = [];

  let scale = 1;
  const avg = sum / data.length;
  if (avg > 4) {
    scale = 4 / avg;
  }

  days.forEach(function (day, idx) {
    title.push({
      textBaseline: 'middle',
      left: 0,
      top: ((idx + 0.5) * 100) / 7 + '%',
      text: day,
    });
    singleAxis.push({
      type: 'category',
      boundaryGap: false,
      data: hours,
      left: 125,
      top: (idx * 100) / 7 + 5 + '%',
      height: 100 / 7 - 10 + '%',
      axisLabel: {
        interval: 2,
      },
    });
    series.push({
      singleAxisIndex: idx,
      coordinateSystem: 'singleAxis',
      type: 'scatter',
      data: [],
      symbolSize: (item: [number, number]) => {
        return item[1] * 4 * scale;
      },
    });
  });

  data.forEach((item) => {
    (series[item[0]].data as [number, number][]).push([item[1], item[2]]);
  });

  const option: ScatterChartOption = {
    color: ['#1890FF'],
    tooltip: {
      position: 'top',
      padding: [10, 10],
      confine: true,
      borderColor: '#FFFFFF',
      formatter: function (params) {
        const p = params as CallbackDataParams;
        //@ts-expect-error
        const time = hours[p.data[0]];
        //@ts-expect-error
        const timeEnd = hours[(p.data[0] + 1) % hours.length];
        const dow = typeof p.seriesIndex === 'number' ? days[p.seriesIndex] : '';
        //@ts-expect-error
        const count = p.data[1];
        return `${count} on ${dow}s between ${time}m and ${timeEnd}m`;
      },
    },
    title,
    singleAxis,
    series,
  };

  return option;
};

export const DowHourChartComponent = ({ data }: { data: [number, number, number][] }) => {
  const option = useMemo(() => getOption(data), [data]);

  return option ? (
    <ReactECharts option={option} style={{ height: 400 }} />
  ) : (
    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} style={{ padding: 60 }} />
  );
};
